import React, { Component } from 'react';
import { Row, Col, Table } from "react-bootstrap";
import { toast } from 'react-toastify';

class BecaFamilia2 extends Component {
    state = {
        familia: [],
        parentesco: "",
        nombre: "",
        parentesco: "",
        apellido: "",
        edad: "",
        instruccion: "",
        ocupacion: "",
        aporte: "",
        dependen: this.props.datos.dependen.text,
        trabajan: this.props.datos.trabajan.text
    }

    cambiaState = (prop) => (e) => {
        this.setState({
            [prop]: (e.target.value).toUpperCase()
        })
    }

    cambiaValor = (prop, err) => (e) => {
        let campo ={
            text: e.target.value,
            errMess: err
        }
        this.props.funcion(prop, campo, "datosBecaFamilia2")
    }

    addMiembro = () => {
        let { familia, nombre, parentesco, apellido, edad, instruccion, ocupacion, aporte } = this.state;

        if (nombre === "" || parentesco === "" || parentesco === "" || apellido === "" || edad === "" || instruccion === "" || ocupacion === "" || aporte === "") {
            toast.error("Para agregar un miembro del grupo familiar debes completar todos los campos",{autoClose: 4000});
            return null;    
        }

        if (!isNaN(Number(edad)) === false){
            toast.error("El campo de la Edad debe se numérico",{autoClose: 4000});
            return null; 
        }

        if (!isNaN(Number(aporte)) === false){
            toast.error("El campo de Aporte Bs. debe se numérico",{autoClose: 4000});
            return null; 
        }

        familia.push({
            id: familia.length + 1,
            nombre: nombre,
            parentesco: parentesco,
            apellido: apellido,
            edad: edad,
            instruccion: instruccion,
            ocupacion: ocupacion,
            aporte: aporte
        })

        this.setState({
            nombre: "",
            parentesco: "",
            apellido: "",
            edad: "",
            instruccion: "",
            ocupacion: "",
            aporte: ""
        })

        let campo = { value: familia, errMess: "" }
        this.props.funcion("familia", campo, "datosBecaFamilia2")
    }

    render() {
        let { familia, nombre, parentesco, apellido, edad, instruccion, ocupacion, aporte, dependen, trabajan } = this.state;

        const styles = {
            padding: 5, fontSize: 10
        }

        let familiaTable = () => {
            if (familia.length === 0) return (
                <tr>
                    <td colSpan={7} align="center" className="text-muted" style={{padding: 5, fontSize: 12}}>Ningún Familiar Registrado</td>
                </tr>
            )

            return (
                familia.map(option => (
                    <tr key={option.id}>
                        <td align="center" style={styles}>{option.parentesco}</td>
                        <td style={styles}>{option.nombre}</td>
                        <td align="center" style={styles}>{option.apellido}</td>
                        <td align="center" style={styles}>{option.edad}</td>
                        <td align="center" style={styles}>{option.instruccion}</td>
                        <td align="center" style={styles}>{option.ocupacion}</td>
                        <td align="center" style={{padding: 5, fontSize: 9}}>{option.aporte} Bs.</td>
                    </tr>
                ))
            )
        }

        return (
            <div style={{paddingRight: 10, paddingLeft: 20}}>
                <div className="custom-alert-warning custom-mt-10">Miembros del Grupo Familiar</div>
                <Row>
                    <Col md={10} className="custom-mt-10">
                        <Row>
                            <Col md={4}>
                                <div className="text-muted">Parentesco</div>
                                <input type="text" value={parentesco} onChange={this.cambiaState("parentesco")} className="form-control"/>
                            </Col>
                            <Col md={4}>
                                <div className="text-muted">Nombre</div>
                                <input type="text" value={nombre} onChange={this.cambiaState("nombre")} className="form-control"/>
                            </Col>
                            <Col md={4}>
                                <div className="text-muted">Apellido</div>
                                <input type="text" value={apellido} onChange={this.cambiaState("apellido")} className="form-control"/>
                            </Col>

                            <Col md={2} className="custom-mt-10">
                                <div className="text-muted">Edad</div>
                                <input type="text" value={edad} onChange={this.cambiaState("edad")} className="form-control"/>
                            </Col>
                            <Col md={4} className="custom-mt-10">
                                <div className="text-muted">Grado Instrucción</div>
                                <input type="text" value={instruccion} onChange={this.cambiaState("instruccion")} className="form-control"/>
                            </Col>
                            <Col md={3} className="custom-mt-10">
                                <div className="text-muted">Ocupación</div>
                                <input type="text" value={ocupacion} onChange={this.cambiaState("ocupacion")} className="form-control"/>
                            </Col>
                            <Col md={3} className="custom-mt-10">
                                <div className="text-muted">Aporte Bs.</div>
                                <input type="text" value={aporte} onChange={this.cambiaState("aporte")} className="form-control"/>
                            </Col>
                        </Row>
                    </Col>
                    <Col md={2} align="right" className="custom-mt-10" style={{paddingTop: 20}}>
                        <button className="btn btn-primary" onClick={this.addMiembro} style={{borderWidth:1}}>Agregar</button>
                    </Col>
                    <Col md={12} className="custom-mt-10">
                        <div className="table-responsive" style={{backgroundColor:"#FFF"/* , overflowX:"hidden", overflowY: "auto", maxHeight: 200 */}}>
                            <Table striped hover bordered>
                                <tbody>
                                    <tr className="custon-back-color-warning">
                                        <td align="center" width="10%" style={styles}><strong>Parentesco</strong></td>
                                        <td width="20%" style={styles}><strong>Nombre</strong></td>
                                        <td align="center" width="20%" style={styles}><strong>Apellido</strong></td>
                                        <td align="center" width="8%" style={styles}><strong>Edad</strong></td>
                                        <td align="center" width="16%" style={styles}><strong>Grado Instrucción</strong></td>
                                        <td align="center" width="16%" style={styles}><strong>Ocupación</strong></td>
                                        <td align="center" width="10%" style={{padding: 5, fontSize: 9}}><strong>Aporte Económico Bs.</strong></td>
                                    </tr>
                                    {familiaTable()}
                                </tbody>
                            </Table>
                        </div>
                    </Col>
                    <Col md={6} className="custom-mt-10">
                        <div className="text-muted" style={{fontSize: 12}}>N° de personas que dependen del responsable económico</div>
                        <input type="text" value={dependen} onChange={this.cambiaState("dependen")} onBlur={this.cambiaValor("dependen", "Debes indicar el número de personas que dependen del responsable económico")} className="form-control" placeholder="Ingresa la cantidad"/>
                    </Col>
                    <Col md={6} className="custom-mt-10">
                        <div className="text-muted" style={{fontSize: 12}}>N° de miembros del grupo familiar que trabajan</div>
                        <input type="text" value={trabajan} onChange={this.cambiaState("trabajan")} onBlur={this.cambiaValor("trabajan", "Debes indicar el número de miembros del grupo familiar que trabajan")} className="form-control" placeholder="Ingresa la cantidad"/>
                    </Col>
                </Row>
            </div>
        );
    }
}
 
export default BecaFamilia2;


// WEBPACK FOOTER //
// ./src/views/EstSolicitudes/BecaFamilia2.jsx